"use strict";function stopMatchRuleFromPartner$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.stopMatchRuleFromPartner$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.pbp.stopMatchRuleFromPartner";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.10"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.10"},_a)),exports.stopMatchRuleFromPartner$=stopMatchRuleFromPartner$,exports.default=stopMatchRuleFromPartner$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/pbp/stopMatchRuleFromPartner.js
// module id = 982
// module chunks = 106